// this file is automatically generated by git.revision.js script
export const versions = { revision: '8c17223bad' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '8c17223bad';
